'use strict';

/**
*        
*   ---=== FlexTools ===---
*   https://zhangfisher.github.com/flex-tools
* 
*   一些实用工具函数
*
*/
function r(t,n=!1){if(typeof t=="number")return !0;if(typeof t!="string"||n)return !1;try{if(t.includes(".")){let e=parseFloat(t);return t.endsWith(".")?!isNaN(e)&&String(e).length===t.length-1:!isNaN(e)&&String(e).length===t.length}else {let e=parseInt(t);return !isNaN(e)&&String(e).length===t.length}}catch(e){return !1}}

exports.a = r;
